<template>
<div v-else class="wheel">
  WHEEL
  <div>
    <li v-for="spin in overlayData">
      {{spin}}
    </li>
  </div>
</div>
</template>

<script>
  import axios from 'axios'

  export default {
    mounted() {
      this.loadData()
    },
    data () {
      return {
        overlayData: []
      }
    },
    methods: {
      loadData () {
        axios.get(`/api/overlay/display`).then(({ data }) => {
          this.overlayData = data.overlay.spins
        })
      }
    }
  }
</script>

<style scoped>
.wheel {
	position:fixed;
  font-size: 13;
	background-color:black;
	color:white;
	height:37vh;
	width:35vw;
	top:60vh;
	left:65vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Wheelspins.vue